import { useEffect, useState } from "react";
import { service } from "../services/service";
import { Button, Col, Row, Table, Modal, Popconfirm, Badge } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${date}/${month}/${year}`;
}

function TableCampaigns() {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Start date",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "End date",
      dataIndex: "end_date",
      key: "end_date",
    },
    {
      title: "Campaign",
      dataIndex: "id_customer",
      key: "campaign",
      render: (value) => value && value.agency,
    },
    {
      title: "Leads",
      dataIndex: "leads",
      key: "leads",
      render: (text, record, index) => (
        <Badge
          count={countsLead(index)}
          showZero
          color="blue"
          overflowCount={100000}
        ></Badge>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (text, record, index) => (
        <Button
          type="link"
          onClick={() => {
            showModal(index);
          }}
        >
          see leads
        </Button>
      ),
    },
  ];
  const columnsLeads = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Surname",
      dataIndex: "surname",
      key: "surname",
    },
    {
      title: "Municipality",
      dataIndex: "municipality",
      key: "municipality",
    },
    {
      title: "Agency",
      dataIndex: "agency",
      key: "agency",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (value) => <div style={{ maxWidth: "200px" }}>{value}</div>,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Related Campaign",
      dataIndex: "id_campaign",
      key: "campaign name",
      render: (value) => value.name,
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (text) => (
        <Popconfirm
          title="Delete Lead"
          description="Are you sure to delete this Lead?"
          onConfirm={() => service.deleteLead(text._id)}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="deafult"
            style={{ color: "red" }}
            icon={<DeleteOutlined />}
          />
        </Popconfirm>
      ),
    },
  ];
  const [tableValue, setTableValue] = useState();
  const [tableValueLeads, setTableValueLeads] = useState([]);
  const [tableValueTotalLeads, setTableValueTotalLeads] = useState([]);
  const [currentDate] = useState(getDate());
  const [selectedLead, setSelectedLead] = useState();

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const loggedStorage = localStorage.getItem("user");
    if (loggedStorage === null) {
      window.location.assign("/login");
    }
    showTotalLead();
  }, []);

  function countsLead(index) {
    var campaign = tableValue[index].id;
    let listLead = tableValueTotalLeads;
    let i = 0;
    listLead.forEach((item) => {
      if (campaign === item.id_campaign.id) {
        i++;
      }
    });
    return i;
  }

  function showModal(index) {
    var name = tableValue[index].name;
    setSelectedLead(tableValue[index].name);
    setIsModalOpen(true);
    service.seeCampaignLeads(name).then((res) => setTableValueLeads(res));
  }

  function showTotalLead() {
    service.showTotalLeadsInCampaign().then((res) => {
      setTableValueTotalLeads(res);
    });
  }

  useEffect(() => {
    getTable();
  }, []);

  function getTable() {
    const role = localStorage.getItem("role");
    let temp = [];
    let i, k;
    service.getCampaignTable().then((res) => {
      for (i = 0; i < res.length; i++) {
        for (k = 0; k < res[i].player_roles_id.length; k++) {
          if (role === res[i].player_roles_id[k].name) {
            temp.push(res[i]);
          }
        }
      }
      setTableValue(temp);
    });
  }

  function saveExel() {
    const worksheet = XLSX.utils.json_to_sheet(tableValue);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Buffer to store the generated Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `campaign_${currentDate}.xlsx`);
  }

  function saveExelLead() {
    const worksheet = XLSX.utils.json_to_sheet(tableValueLeads);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Buffer to store the generated Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `lead_${currentDate}_lead_${selectedLead}.xlsx`);
  }

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Row justify="end">
        <Col span={6}>
          <h1 style={{ margin: 0 }}>Campaigns</h1>
        </Col>
        <Col span={3} offset={15} style={{ textAlign: "end" }}>
          <Button
            type="primary"
            onClick={() => saveExel()}
            style={{ marginBottom: "10px" }}
          >
            Export
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table columns={columns} dataSource={tableValue} />
        </Col>
      </Row>
      <Modal
        title={
          <>
            <strong>Table Leads</strong>
            <Button
              type="primary"
              onClick={() => saveExelLead()}
              style={{ marginBottom: "10px", marginLeft: 10 }}
            >
              Export
            </Button>
          </>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="1000"
      >
        <Row>
          <Col span={24}>
            <Table
              columns={columnsLeads}
              dataSource={tableValueLeads}
              pagination={{ defaultCurrent: 1, pageSize: 8 }}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
}
export default TableCampaigns;
// aggiungere un button che rimanda a cont. con il filtro della campagna selezionato
